export * from './angular-http-client.adapter';
